import axios from 'axios';
import { APIEndpoints } from 'helpers/APILists';
import DataGridComponent from 'components/DataGrid/DataGridComponent';
import { MESSAGE_TYPE } from 'journeys/common/common.constants';
import React, { useState } from 'react';
import { trackErrors } from '../helper';
import {
    correctiveDPSMappingData, correctiveDPSMappingApiEndpoint,
    searchDataInitialState, correctiveDPSMappingInitialState
} from './CorrectiveDPSMapping.data';

import CorrectiveDPSMappingForm from './CorrectiveDPSMappingForm';
import { strEquals } from '../../AdminScreen.helper';

const addTitle = 'Add New Record for Corrective DPS Mapping';
const editTitle = 'Edit Record for Corrective DPS Mapping';

const CorrectiveDPSMapping = () => {
    const apiEndpoints = correctiveDPSMappingApiEndpoint;
    const [showModal, setShowModal] = useState(false);
    const [editRowData, setEditRowData] = useState(correctiveDPSMappingInitialState);
    const [modalTitle, setModalTitle] = useState(addTitle);
    const [refreshDatagrid, setRefreshDatagrid] = useState(false);
    const [trfDetails, setTrfDetails] = useState([]);
    const [rowDetails, setRowDetails] = useState({
        columnName: 'CorrectiveDpsmappingId',
        rowNumber: ''
    });
    const [dropdownsData, setDropdownsData] = useState({
        bpRegionOptions: [],
        assetOptions: [],
        dpsFieldOptions: [],
        dpsSourceOptions: []
    });

    const fetchTrfIdDetails = async () => {
        try {
            const trfIdDetails = await axios.get(APIEndpoints.ADMIN_GetTrfMasterLists);
            setTrfDetails(trfIdDetails.data);
            return trfIdDetails.data;
        } catch (err) {
            trackErrors({
                messageType: MESSAGE_TYPE.ERROR,
                message: err.message,
                exception: err
            });
            throw err;
        }
    };

    const processTrfIdDetails = (trfIdDetails) => {
        setDropdownsData(prev => ({
            ...prev,
            trfIdOptions: trfIdDetails.sort((a, b) => a.TrfId.localeCompare(b.TrfId, undefined, {
                numeric: true,
                sensitivity: 'base'
            })).filter(y => strEquals(y.WorkType, 'Preventative') && !strEquals(y.TrfId, 'NA')).map(x => x.TrfId),
            correctiveTrfIdOptions: trfIdDetails.sort((a, b) => a.TrfId.localeCompare(b.TrfId, undefined, {
                numeric: true,
                sensitivity: 'base'
            })).filter(y => strEquals(y.WorkType, 'Corrective')).map(x => x.TrfId),
        }));
    };

    const parseData = async (data) => {
        try {
            const trfIdDetails = await fetchTrfIdDetails();
            const result = data?.map((res) => ({
                ...res,
                Trf: trfIdDetails.find(x => x?.RowId === res?.Trfid)?.TrfId,
                CorrectiveTrf: trfIdDetails.find(x => x?.RowId === res?.CorrectiveTrfid)?.TrfId,
                Status: res.Status ? 'Active' : 'Inactive',
            }));
            processTrfIdDetails(trfIdDetails);
            return result;
        } catch (err) {
            trackErrors({
                messageType: MESSAGE_TYPE.ERROR,
                message: err.message,
                exception: err
            });
            throw err;
        }
    };

    const handleEditRecord = (obj) => {
        const rowData = obj.row;
        setModalTitle(editTitle);
        setShowModal(true);
        setEditRowData((prev) => ({
            ...prev,
            ...rowData
        }));
    };
    const handleAddRecord = () => {
        setEditRowData(correctiveDPSMappingInitialState);
        setModalTitle(addTitle);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleRecordSubmit = (newId) => {
        setRowDetails(prev => ({ ...prev, rowNumber: newId }));
        setRefreshDatagrid(prev => !prev);
    };

    return (
        <>
            <DataGridComponent
                headerData={correctiveDPSMappingData}
                apiEndpoint={apiEndpoints.read}
                editRecord={handleEditRecord}
                addRecord={handleAddRecord}
                initialData={searchDataInitialState}
                rowDetails={rowDetails}
                dataParser={parseData}
                refreshDatagrid={refreshDatagrid}
            />

            {showModal
                && (
                    <CorrectiveDPSMappingForm
                        isOpen={showModal}
                        onClose={handleModalClose}
                        title={modalTitle}
                        rowData={editRowData}
                        onRecordSubmit={handleRecordSubmit}
                        dropdownsData={dropdownsData}
                        trfDetails={trfDetails}
                    />
                )}
        </>
    );
};

export default CorrectiveDPSMapping;
